export function Action({ children, href, clickHandler, type, ...props }) {
  if (href) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button
      type={type || "button"}
      onClick={(e) => {
        if (clickHandler) {
          clickHandler(e);
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
}
